<div class="modal-header" id="material-history-modal-title">
    <h3 class="modal-title" id="modal-title" translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <div class="d-flex table-header fw-bold py-2">
            <div class="col-1"></div>
            <div class="col-3" (click)="setOrderBy('materialIdentifier.materialNumber.value')">
                <span translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_MATERIAL"></span>
                <span
                    class="sort-order"
                    [hidden]="fieldName !== 'materialIdentifier.materialNumber.value'"
                    [ngClass]="{ reverse: reverse }"
                ></span>
            </div>
            <div class="col-4" (click)="setOrderBy('materialIdentifier.description.value')">
                <span translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_MATERIAL_DESCRIPTION"></span>
                <span
                    class="sort-order"
                    [hidden]="fieldName !== 'materialIdentifier.description.value'"
                    [ngClass]="{ reverse: reverse }"
                ></span>
            </div>
            <div class="col-4" (click)="setOrderBy('materialIdentifier.orderPosition.value')">
                <span translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_NOTIFICATION"> </span>
                <span
                    class="sort-order"
                    [hidden]="fieldName !== 'notificationIdentifier.qmNum'"
                    [ngClass]="{ reverse: reverse }"
                ></span>
            </div>
        </div>
        <div class="table-row" *ngFor="let material of materialHistoryList$ | async | orderBy: fieldName : reverse">
            <pace-material-history-detail [material]="material"></pace-material-history-detail>
        </div>
    </div>
</div>
